import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKDISTRIBUTIONMODEPICKERPAGE_LEGACY_FIELD_ORDER = [
  { type: 'separator' },
  "link_url",
  { type: 'separator' },
  "background_color",
  "background_image",
  "text_color",
  "accent_color",
  { type: 'heading', value: "Cards" },
  "active_card_background_color",
  "active_card_text_color",
  "inactive_card_background_color",
  "inactive_card_text_color",
  { type: 'heading', value: "Footer" },
  "secondary_button_background_color",
  "secondary_button_text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskDistributionModePickerPageDescriptor: _generatedKioskDistributionModePickerPageDescriptor,
  kioskDistributionModePickerPageBlocDefinition,
  kioskDistributionModePickerPageDashboardLayout,
  kioskDistributionModePickerPageConfig,
  kioskDistributionModePickerPageResolveConfig,
  kioskDistributionModePickerPageProperties,
} = doodBlockConfig(
  {
    name: "Kiosk - Distribution mode picker page",
    internal_name: "Kiosk - Distribution mode picker page",
    url: "distribution-mode",
    defaultParent: [/^Main Layout$/i],
    componentType: 'KioskDistributionModePickerPageComponent',
    category: 'page',
    description: "Kiosk - Distribution mode picker page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'header',
        name: "pages.blocks.kiosk-distribution-mode-picker-page.header.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskHeaderBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    link_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.link-url.label",
        help: "pages.blocks.kiosk-distribution-mode-picker-page.link-url.help",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.background-color.label",
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.background-image.label",
        help: "pages.blocks.kiosk-distribution-mode-picker-page.background-image.help",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.text-color.label",
      }
    }),
    accent_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"primary-800"},
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.accent-color.label",
      }
    }),
    active_card_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"primary-800"},
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.active-card-background-color.label",
      }
    }),
    active_card_text_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.active-card-text-color.label",
      }
    }),
    inactive_card_background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"transparent"},
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.inactive-card-background-color.label",
      }
    }),
    inactive_card_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"primary-800"},
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.inactive-card-text-color.label",
      }
    }),
    primary_button_background_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.primary-button-background-color.label",
      }
    }),
    primary_button_text_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.primary-button-text-color.label",
      }
    }),
    secondary_button_background_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.secondary-button-background-color.label",
      }
    }),
    secondary_button_text_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.secondary-button-text-color.label",
      }
    })
  }),

  () => ({
    omitFields: [
      "primary_button_background_color",
      "primary_button_text_color",
    ] as const,
    tabs: [
      {
        label: "pages.blocks.kiosk-distribution-mode-picker-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-distribution-mode-picker-page.fieldset.header.label",
            fields: ["header"],
          },
          {
            legend: "pages.blocks.kiosk-distribution-mode-picker-page.fieldset.navigation.label",
            fields: ["link_url"],
          },
          {
            legend: "pages.blocks.kiosk-distribution-mode-picker-page.fieldset.page.label",
            fields: ["background_color", "background_image", "text_color", "accent_color"],
          },
          {
            legend: "pages.blocks.kiosk-distribution-mode-picker-page.fieldset.active-card.label",
            fields: ["active_card_background_color", "active_card_text_color"],
          },
          {
            legend: "pages.blocks.kiosk-distribution-mode-picker-page.fieldset.inactive-card.label",
            fields: ["inactive_card_background_color", "inactive_card_text_color"],
          },
          {
            legend: "pages.blocks.kiosk-distribution-mode-picker-page.fieldset.validate-button.label",
            fields: ["secondary_button_background_color", "secondary_button_text_color"],
          },
        ],
      },
    ],
  })
);

export function kioskDistributionModePickerPageDescriptor(): IBlockDescriptor;
export function kioskDistributionModePickerPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskDistributionModePickerPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskDistributionModePickerPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskDistributionModePickerPageDescriptor, kioskDistributionModePickerPageProperties, fieldOrder);
}

export {
  kioskDistributionModePickerPageBlocDefinition,
  kioskDistributionModePickerPageDashboardLayout,
  kioskDistributionModePickerPageProperties,
  kioskDistributionModePickerPageConfig,
  kioskDistributionModePickerPageResolveConfig,
};

export type KioskDistributionModePickerPageConfig = typeof kioskDistributionModePickerPageConfig;
